import { render, staticRenderFns } from "./MsdsModule.vue?vue&type=template&id=39f616ab&scoped=true"
import script from "./MsdsModule.vue?vue&type=script&lang=js"
export * from "./MsdsModule.vue?vue&type=script&lang=js"
import style0 from "./MsdsModule.vue?vue&type=style&index=0&id=39f616ab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f616ab",
  null
  
)

export default component.exports